// extracted by mini-css-extract-plugin
export default {"iconButton":"IconButton_iconButton__9TqLU","icon":"IconButton_icon__WlOWl"};